import {
  EquipmentActions,
  PermittingActions,
  ProjectActions,
} from '@store/actions';
import { distructAndDispatch } from '../../core/utils/methods/destruct-and-dispatch';
import {
  EquipmentFullInfo,
  FinancialData,
  PermittingSofData,
  PermittingSummaryData,
  ProjectDetails,
  ProjectPaceTask,
  User,
} from '../../models/interfaces';
import { FinancialActions } from '../actions/financial.actions';

export namespace PermittingEffects {
  export const setPaceTasks = distructAndDispatch<
    PermittingSummaryData,
    ProjectPaceTask[]
  >('paceTasks', ProjectActions.updateProjectPaceTasksAction);

  export const setPaceTaskFields = distructAndDispatch<
    PermittingSummaryData,
    ProjectPaceTask[]
  >('paceTaskFields', ProjectActions.updateProjectPaceTaskFields);

  export const setCurrentProvidenceAgent = distructAndDispatch<
    PermittingSummaryData,
    User
  >('providenceAgent', ProjectActions.setCurrentProvidenceAgent);

  export const setFinancial = distructAndDispatch<
    ProjectDetails & { financial?: FinancialData | null },
    FinancialData
  >('financial', FinancialActions.getFinancialDataAction);

  export const setLoadingTab = distructAndDispatch<
    { tabLoadingData: { tabName: string; isLoading: boolean } },
    { tabName: string; isLoading: boolean }
  >('tabLoadingData', PermittingActions.setTabLoading);

  export const setEquipmentsByTypes = distructAndDispatch<
    PermittingSofData,
    EquipmentFullInfo[]
  >('equipmentsByTypes', EquipmentActions.getEquipmentsByTypes);
}
